module.exports = __webpack_public_path__ + "img/jifen.73e0fb90.png";